import {queryClient} from 'base'
import {User} from 'modules/users'

export const isBorrowerFromProfileQuery = (): boolean => {
  const profile: User = queryClient.getQueryData('profile')
  return profile.role === 'user'
}
